import React from 'react'
import PropTypes from 'prop-types'

function LessonPlanPage(props) {
    const {objective, content, reference} = props.data
  return (
    <div >
        <h3><u>Lesson Objectives</u></h3>
        <i>At the end of the lesson you should be able to:</i>
        <p>
        <div style={{whiteSpace:'pre-wraps'}}  dangerouslySetInnerHTML={{__html: objective}} />
        </p>
        <h3><u>Lesson Content</u></h3>
        <p>
        <div style={{whiteSpace:'pre-wraps'}}  dangerouslySetInnerHTML={{__html: content}} />
        </p>
        <h3><u>Reference(s)</u></h3>
        <p>
        <div style={{whiteSpace:'pre-wraps'}}  dangerouslySetInnerHTML={{__html: reference}} />
        </p>
    </div>
  )
}

LessonPlanPage.propTypes = {}

export default LessonPlanPage
